var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path3, _path4, _path5, _path6, _g8, _g9, _path7, _g10, _g11, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgResearch = function SvgResearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 216,
    viewBox: "0 0 214 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Research"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Right-5",
    d: "M207.179 173.495H186.412C185.893 173.495 185.466 172.762 185.466 171.855V144.158C185.466 143.252 185.893 142.519 186.412 142.519H207.179C207.952 142.519 208.405 144.025 207.952 145.105L202.993 157.06C202.753 157.634 202.753 158.393 202.993 158.953L207.952 170.909C208.405 171.989 207.952 173.495 207.179 173.495Z",
    fill: "#4539FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Left-5",
    d: "M10.9535 142.532H31.7196C32.2394 142.532 32.666 143.265 32.666 144.172V171.869C32.666 172.775 32.2394 173.508 31.7196 173.508H10.9535C10.1804 173.508 9.72726 172.002 10.1804 170.922L15.1387 158.966C15.3786 158.393 15.3786 157.634 15.1387 157.074L10.1804 145.118C9.72726 144.038 10.1804 142.532 10.9535 142.532Z",
    fill: "#4539FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back-5",
    filter: "url(#filter0_d_1241_129502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2555 57.9482V155.688C24.2555 161.899 28.2674 167.39 34.1721 169.283L102.295 191.102C105.121 192.008 108.173 192.008 110.999 191.102L179.122 169.283C185.026 167.39 189.038 161.899 189.038 155.688V57.9482C189.038 51.5904 184.84 46.0057 178.722 44.233L110.599 24.5598C108.013 23.8134 105.267 23.8134 102.682 24.5598L34.5586 44.233C28.4541 45.9923 24.2422 51.5904 24.2422 57.9482H24.2555Z",
    fill: "url(#paint0_linear_1241_129502)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Front-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.587 61.7202V152.062C29.587 158.18 33.5457 163.605 39.3703 165.471L102.362 185.65C105.161 186.543 108.16 186.543 110.945 185.65L173.937 165.471C179.761 163.605 183.72 158.18 183.72 152.062V61.7202C183.72 55.4557 179.575 49.9376 173.55 48.1916L110.559 29.9979C108.013 29.2649 105.294 29.2649 102.748 29.9979L39.7568 48.1916C33.7322 49.9376 29.587 55.4424 29.587 61.7202Z",
    fill: "url(#paint1_linear_1241_129502)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Base-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1241_129502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 29,
    width: 155,
    height: 158
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Front-10",
    d: "M29.587 61.7202V152.062C29.587 158.18 33.5457 163.605 39.3703 165.471L102.362 185.65C105.161 186.543 108.16 186.543 110.945 185.65L173.937 165.471C179.761 163.605 183.72 158.18 183.72 152.062V61.7202C183.72 55.4557 179.575 49.9376 173.55 48.1916L110.559 29.9979C108.013 29.2649 105.294 29.2649 102.748 29.9979L39.7568 48.1916C33.7322 49.9376 29.587 55.4424 29.587 61.7202Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1241_129502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M106.654 236.899C161.429 236.899 205.832 210.66 205.832 178.293C205.832 145.926 161.429 119.687 106.654 119.687C51.8786 119.687 7.47473 145.926 7.47473 178.293C7.47473 210.66 51.8786 236.899 106.654 236.899Z",
    fill: "#F28723"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Stars-5",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M58.5637 108.264C60.4629 108.264 62.0025 106.725 62.0025 104.825C62.0025 102.926 60.4629 101.386 58.5637 101.386C56.6645 101.386 55.1249 102.926 55.1249 104.825C55.1249 106.725 56.6645 108.264 58.5637 108.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M158.649 116.954L156.65 120.233C156.343 120.74 155.597 120.74 155.277 120.233L153.277 116.954C153.117 116.701 153.117 116.381 153.277 116.115L155.277 112.836C155.583 112.329 156.33 112.329 156.65 112.836L158.649 116.115C158.809 116.368 158.809 116.701 158.649 116.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M71.9589 49.2446L70.3862 51.817C70.1462 52.2168 69.5598 52.2168 69.3065 51.817L67.7338 49.2446C67.6138 49.0446 67.6138 48.7914 67.7338 48.5914L69.3065 46.019C69.5465 45.6192 70.1329 45.6192 70.3862 46.019L71.9589 48.5914C72.0789 48.7914 72.0789 49.0446 71.9589 49.2446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M103.788 62.9465L102.615 64.8525C102.428 65.1457 102.002 65.1457 101.815 64.8525L100.656 62.9465C100.562 62.7999 100.562 62.6133 100.656 62.4533L101.815 60.5473C102.002 60.2541 102.428 60.2541 102.615 60.5473L103.788 62.4533C103.881 62.5999 103.881 62.7865 103.788 62.9465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M100.296 72.4632L98.0299 76.1685C97.6701 76.7417 96.8303 76.7417 96.4838 76.1685L94.2179 72.4632C94.0446 72.1699 94.0446 71.8101 94.2179 71.5168L96.4838 67.8114C96.8437 67.2383 97.6834 67.2383 98.0299 67.8114L100.296 71.5168C100.469 71.8101 100.469 72.1699 100.296 72.4632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M44.8618 119.713C45.8187 119.713 46.5945 118.938 46.5945 117.981C46.5945 117.024 45.8187 116.248 44.8618 116.248C43.9048 116.248 43.129 117.024 43.129 117.981C43.129 118.938 43.9048 119.713 44.8618 119.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M60.2431 126.764C61.6564 126.764 62.8022 125.618 62.8022 124.205C62.8022 122.792 61.6564 121.646 60.2431 121.646C58.8297 121.646 57.684 122.792 57.684 124.205C57.684 125.618 58.8297 126.764 60.2431 126.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M161.368 103.439L159.955 105.745C159.728 106.105 159.209 106.105 158.995 105.745L157.583 103.439C157.476 103.252 157.476 103.026 157.583 102.853L158.995 100.547C159.222 100.187 159.742 100.187 159.955 100.547L161.368 102.853C161.475 103.039 161.475 103.266 161.368 103.439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M153.517 53.803C154.864 53.803 155.956 52.7109 155.956 51.3638C155.956 50.0167 154.864 48.9247 153.517 48.9247C152.17 48.9247 151.078 50.0167 151.078 51.3638C151.078 52.7109 152.17 53.803 153.517 53.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M152.798 65.079C153.755 65.079 154.53 64.3032 154.53 63.3463C154.53 62.3893 153.755 61.6135 152.798 61.6135C151.841 61.6135 151.065 62.3893 151.065 63.3463C151.065 64.3032 151.841 65.079 152.798 65.079Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shine-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1241_129502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 24,
    width: 166,
    height: 168
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M24.2556 58.0148V155.608C24.2556 161.859 28.2942 167.39 34.2388 169.296L102.268 191.089C105.121 192.008 108.186 192.008 111.039 191.089L179.068 169.296C185.026 167.39 189.052 161.859 189.052 155.608V58.0148C189.052 51.6171 184.813 45.979 178.669 44.2063L110.639 24.5598C108.04 23.8134 105.267 23.8134 102.668 24.5598L34.6387 44.2063C28.4941 45.979 24.2556 51.6171 24.2556 58.0148Z",
    fill: "white"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1241_129502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.15,
    d: "M15.6986 241.671C13.0995 234.42 11.7933 230.328 9.19421 221.185C26.6148 208.256 45.3283 199.512 63.8552 188.503C83.4484 176.867 99.3495 161.659 116.65 146.957C152.464 116.554 178.829 111.196 224.119 123.365C226.719 125.698 228.025 126.897 230.624 129.497C184.453 115.861 158.409 126.684 123.155 157.673C88.8332 187.863 48.0207 209.802 15.6853 241.658L15.6986 241.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.15,
    d: "M5.68876 225.503C-10.1457 197.433 -17.1833 164.351 -24.5674 133.389C22.8028 134.148 48.1007 110.397 82.9019 81.3667C118.423 51.737 146.107 43.8864 190.371 58.5746C200.848 68.9843 210.897 79.2207 220.627 90.3369C174.59 68.4778 144.587 98.4007 113.158 130.536C79.1565 165.311 41.0498 192.648 5.68876 225.503Z",
    fill: "white"
  })))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M104.134 110.53L101.375 119.62L92.2852 116.861L95.0443 107.771",
    fill: "#805FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    opacity: 0.5,
    d: "M108.839 106.011C122.701 106.011 133.937 94.7747 133.937 80.9135C133.937 67.0523 122.701 55.8156 108.839 55.8156C94.9783 55.8156 83.7416 67.0523 83.7416 80.9135C83.7416 94.7747 94.9783 106.011 108.839 106.011Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M108.826 55.8023C111.239 55.8023 113.691 56.1488 116.117 56.8952C129.379 60.9205 136.883 74.9423 132.858 88.2043C129.566 99.0406 119.609 106.025 108.839 106.025C106.427 106.025 103.974 105.678 101.549 104.932C88.2866 100.907 80.7825 86.8848 84.8078 73.6227C88.1 62.7865 98.0565 55.8023 108.826 55.8023ZM108.826 47.4585C93.9913 47.4585 81.1424 57.0018 76.8239 71.2102C71.4658 88.8574 81.4756 107.571 99.1228 112.929C102.282 113.889 105.561 114.382 108.839 114.382C123.674 114.382 136.523 104.839 140.842 90.6301C143.441 82.0864 142.548 73.0363 138.336 65.159C134.124 57.2817 127.1 51.5104 118.543 48.9246C115.384 47.965 112.105 47.4718 108.826 47.4718V47.4585Z",
    fill: "url(#paint2_radial_1241_129502)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M88.44 118.29L74.3179 164.859C73.9163 166.184 74.6643 167.583 75.9886 167.984L86.4861 171.168C87.8104 171.569 89.2096 170.821 89.6112 169.497L103.733 122.928C104.135 121.604 103.387 120.205 102.063 119.803L91.5651 116.62C90.2407 116.218 88.8416 116.966 88.44 118.29Z",
    fill: "#311BB5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1241_129502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 55,
    width: 51,
    height: 52
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M108.839 106.011C122.701 106.011 133.937 94.7747 133.937 80.9135C133.937 67.0523 122.701 55.8156 108.839 55.8156C94.9783 55.8156 83.7416 67.0523 83.7416 80.9135C83.7416 94.7747 94.9783 106.011 108.839 106.011Z",
    fill: "white"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1241_129502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    opacity: 0.7,
    d: "M138.969 67.2608L78.8547 80.9736L81.321 91.7854L141.435 78.0725L138.969 67.2608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    opacity: 0.7,
    d: "M141.656 79.9545L81.542 93.6674L81.954 95.4736L142.068 81.7608L141.656 79.9545Z",
    fill: "white"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M108.826 55.8023C111.239 55.8023 113.691 56.1489 116.117 56.8953C129.379 60.9205 136.883 74.9424 132.858 88.2044C129.566 99.0406 119.609 106.025 108.839 106.025C106.427 106.025 103.974 105.678 101.549 104.932C88.2866 100.907 80.7826 86.8848 84.8078 73.6228C88.1 62.7866 98.0565 55.8023 108.826 55.8023ZM108.826 54.7627C97.2302 54.7627 87.1803 62.2268 83.8082 73.3296C81.7822 80.0072 82.4753 87.0848 85.7675 93.2427C89.0597 99.4005 94.5511 103.906 101.242 105.932C103.721 106.678 106.28 107.065 108.839 107.065C120.435 107.065 130.485 99.6004 133.857 88.4976C135.883 81.82 135.19 74.7424 131.898 68.5845C128.606 62.4267 123.115 57.9216 116.423 55.8956C113.944 55.1492 111.385 54.7627 108.826 54.7627Z",
    fill: "#4128D5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1241_129502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 116,
    width: 30,
    height: 56
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M88.44 118.29L74.3179 164.859C73.9163 166.184 74.6643 167.583 75.9886 167.984L86.4861 171.168C87.8104 171.569 89.2096 170.821 89.6112 169.497L103.733 122.928C104.135 121.604 103.387 120.205 102.063 119.803L91.5651 116.62C90.2407 116.218 88.8416 116.966 88.44 118.29Z",
    fill: "white"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1241_129502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    opacity: 0.5,
    d: "M87.4869 130.283C87.4869 130.283 90.5391 118.101 93.5914 118.86C91.912 118.167 91.2856 116.914 89.2329 121.273C88.5132 122.806 85.6875 133.309 85.6875 133.309C85.6875 133.309 86.9671 131.829 87.4869 130.283Z",
    fill: "#9B91FF"
  })))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M108.826 48.6048C111.932 48.6048 115.091 49.0579 118.21 50.0043C135.284 55.1758 144.92 73.2229 139.749 90.2836C135.524 104.225 122.701 113.222 108.853 113.222C105.747 113.222 102.588 112.769 99.4694 111.823C82.3954 106.651 72.7587 88.6042 77.9303 71.5434C82.1555 57.6016 94.9776 48.6048 108.826 48.6048ZM108.826 47.2585C93.9114 47.2585 80.9825 56.8552 76.6507 71.1436C74.0383 79.7406 74.9446 88.8441 79.1698 96.7747C83.395 104.705 90.4726 110.503 99.0696 113.116C102.255 114.089 105.547 114.568 108.853 114.568C123.768 114.568 136.696 104.972 141.028 90.6834C146.413 72.9296 136.35 54.1095 118.596 48.7247C115.411 47.7517 112.118 47.2719 108.826 47.2719V47.2585Z",
    fill: "#9B91FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M182.667 180.066C131.645 161.046 83.1284 161.006 32.0928 179.932C30.2268 180.719 28.1209 180.039 27.3878 178.386C24.962 168.19 23.8557 163.045 21.8964 152.689C21.2033 151.009 22.4162 148.917 24.6154 148.063C79.9295 129.537 132.285 129.817 187.359 149.103C189.545 149.943 190.758 152.009 190.078 153.688C189.318 163.698 188.772 168.67 187.385 178.52C186.652 180.172 184.546 180.839 182.68 180.052L182.667 180.066Z",
    fill: "#4539FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M74.7314 158.7L72.2389 155.528L71.6924 155.621L72.2656 159.113L70.013 159.486L68.4935 150.249L72.2656 149.636C72.9986 149.516 73.6384 149.543 74.1849 149.716C74.7447 149.89 75.1845 150.169 75.5044 150.569C75.8376 150.969 76.0376 151.449 76.1309 151.982C76.2375 152.595 76.1442 153.168 75.8776 153.715C75.611 154.261 75.1579 154.675 74.5181 154.994L77.2505 158.3L74.718 158.713L74.7314 158.7ZM71.4392 154.021L72.8387 153.795C73.2519 153.728 73.5451 153.582 73.7184 153.342C73.8916 153.102 73.945 152.809 73.8917 152.435C73.8383 152.089 73.6917 151.822 73.4518 151.662C73.2119 151.489 72.892 151.449 72.4788 151.516L71.0793 151.742L71.4525 154.035L71.4392 154.021Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M80.8225 150.236L81.0491 152.115L84.0747 151.742L84.288 153.488L81.2624 153.861L81.5156 155.901L84.9411 155.474L85.1677 157.287L79.4763 157.993L78.3301 148.703L84.0214 147.997L84.248 149.81L80.8225 150.236Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M89.0063 156.674C88.4465 156.501 87.9933 156.207 87.6334 155.794C87.2736 155.394 87.0603 154.874 86.9937 154.275L89.4062 154.075C89.4728 154.421 89.6061 154.675 89.8327 154.835C90.0459 154.994 90.3259 155.061 90.6591 155.034C90.9923 155.008 91.2589 154.901 91.4321 154.741C91.6187 154.568 91.6987 154.341 91.672 154.075C91.6587 153.848 91.5654 153.662 91.3921 153.528C91.2189 153.395 91.0189 153.288 90.7923 153.208C90.5658 153.128 90.2325 153.048 89.806 152.955C89.1929 152.822 88.6864 152.675 88.2865 152.515C87.8867 152.355 87.5402 152.115 87.2336 151.769C86.927 151.422 86.7538 150.969 86.7005 150.383C86.6338 149.516 86.887 148.81 87.4735 148.263C88.06 147.717 88.8597 147.41 89.8727 147.317C90.899 147.237 91.752 147.41 92.4184 147.85C93.0849 148.29 93.4848 148.943 93.6047 149.823L91.1522 150.036C91.1123 149.743 90.979 149.503 90.7657 149.356C90.5524 149.196 90.2859 149.13 89.966 149.17C89.6861 149.196 89.4728 149.29 89.3262 149.45C89.1663 149.61 89.0996 149.823 89.1263 150.103C89.1529 150.409 89.3129 150.623 89.6061 150.769C89.8993 150.916 90.3658 151.062 90.979 151.209C91.5921 151.369 92.0986 151.516 92.4984 151.676C92.8849 151.836 93.2315 152.075 93.538 152.409C93.8446 152.742 94.0179 153.182 94.0712 153.742C94.1112 154.275 94.0179 154.768 93.7913 155.221C93.5514 155.674 93.1915 156.061 92.6984 156.354C92.2052 156.647 91.6054 156.834 90.9123 156.887C90.2325 156.94 89.6061 156.887 89.0463 156.714L89.0063 156.674Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M98.4831 148.717L98.5631 150.609L101.615 150.476L101.695 152.235L98.643 152.369L98.7364 154.421L102.188 154.261L102.268 156.087L96.5371 156.341L96.1239 146.997L101.855 146.744L101.935 148.57L98.4831 148.717Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M110.439 154.355H106.947L106.387 156.007H104.001L107.373 146.651H110.012L113.411 156.007H110.999L110.439 154.355ZM109.852 152.595L108.693 149.17L107.547 152.595H109.852Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M120.036 156.301L118.263 152.688L117.716 152.662L117.556 156.194L115.277 156.087L115.717 146.744L119.542 146.917C120.275 146.957 120.902 147.104 121.408 147.397C121.915 147.677 122.288 148.05 122.528 148.503C122.768 148.97 122.875 149.463 122.848 150.023C122.821 150.649 122.621 151.196 122.248 151.662C121.875 152.129 121.342 152.462 120.649 152.635L122.635 156.434L120.062 156.314L120.036 156.301ZM117.783 151.049L119.196 151.116C119.609 151.129 119.929 151.049 120.142 150.849C120.355 150.649 120.475 150.369 120.489 149.996C120.502 149.636 120.409 149.356 120.209 149.143C120.009 148.93 119.702 148.81 119.289 148.797L117.876 148.73L117.77 151.049H117.783Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M125.674 149.45C126.14 148.77 126.753 148.263 127.5 147.917C128.246 147.57 129.072 147.464 129.979 147.544C131.085 147.65 132.005 148.037 132.738 148.69C133.471 149.343 133.924 150.196 134.084 151.236L131.592 150.996C131.445 150.583 131.205 150.263 130.885 150.036C130.565 149.81 130.192 149.663 129.752 149.623C129.059 149.556 128.459 149.743 127.979 150.196C127.5 150.636 127.22 151.276 127.14 152.089C127.06 152.902 127.22 153.568 127.606 154.101C127.993 154.634 128.539 154.928 129.232 154.994C129.672 155.034 130.059 154.968 130.419 154.794C130.779 154.621 131.072 154.355 131.298 153.981L133.791 154.221C133.431 155.208 132.831 155.954 131.978 156.447C131.138 156.954 130.165 157.154 129.059 157.047C128.153 156.954 127.366 156.687 126.7 156.207C126.02 155.741 125.527 155.128 125.194 154.368C124.861 153.608 124.741 152.782 124.834 151.862C124.927 150.942 125.194 150.143 125.66 149.463L125.674 149.45Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M145.12 149.61L143.747 158.86L141.495 158.526L142.055 154.714L138.549 154.195L137.989 158.007L135.737 157.673L137.11 148.423L139.362 148.757L138.829 152.382L142.334 152.902L142.868 149.276L145.12 149.61Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1241_129502",
    x: 0.250534,
    y: 0.00834656,
    width: 212.779,
    height: 215.765,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.9958
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129502"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129502",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1241_129502",
    x1: 106.654,
    y1: 104.772,
    x2: 106.654,
    y2: 269.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1241_129502",
    x1: 106.654,
    y1: 252.654,
    x2: 106.654,
    y2: -51.3604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFAE4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF5696"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1241_129502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.839 80.9135) scale(33.455 33.455)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#61D4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#64C3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#6E99F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7969F8"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgResearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "research.e9b7b27.svg";